import { extractInvokeCopyLinkAction } from '../../action/extract-invoke-copy-link-action';
export var extractCopyLinkClientAction = function extractCopyLinkClientAction(param) {
  var invokeAction = extractInvokeCopyLinkAction(param);
  return invokeAction ? {
    invokeAction: invokeAction
  } : undefined;
};